import { Outlet } from "react-router-dom";

export default function LoginContainer() {
  // ✅ 로그인 성공 시 메인 레이아웃 렌더링
  return (
    <div className="login container">
      <header>
        <h1>
          <a to="/project">
            <img src="/images/mainLogo.png" alt="" />
          </a>
        </h1>
        <div>
          <img src="/images/korea_icon.png" alt="" />
          <p></p>
          <button title="로그아웃"></button>
        </div>
      </header>
      <aside>
        <ul>
          <li>
            <span></span>
            <p></p>
          </li>
          <li>
            <span></span>
            <p></p>
          </li>
          <li>
            <span></span>
            <p></p>
          </li>
          <li>
            <span></span>
            <p></p>
          </li>
        </ul>
        <span></span>
        <ul>
          <li>
            <span></span>
            <p></p>
          </li>
          <li>
            <span></span>
            <p></p>
          </li>
          <li>
            <span></span>
            <p></p>
          </li>
          <li>
            <span></span>
            <p></p>
          </li>
        </ul>
        <ul>
          <li>
            <span></span>
            <p></p>
          </li>
          <li>
            <span></span>
            <p></p>
          </li>
        </ul>
      </aside>
      <section className="content">
        <div>
          <span></span> / <span></span>
        </div>
        <div>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <div></div>
        </div>
        <div>
          <span>
            <span></span>
          </span>
          <span>
            <span></span>
          </span>
          <span>
            <span></span>
          </span>
          <span>
            <span></span>
          </span>
        </div>
        <div></div>
        <div>
          <Outlet />
        </div>
      </section>
      <footer></footer>
    </div>
  );
}
